import { render, staticRenderFns } from "./Fakkel.vue?vue&type=template&id=b0fef3c6&scoped=true&"
import script from "./Fakkel.vue?vue&type=script&lang=js&"
export * from "./Fakkel.vue?vue&type=script&lang=js&"
import style0 from "./Fakkel.vue?vue&type=style&index=0&id=b0fef3c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fef3c6",
  null
  
)

export default component.exports